import { rem } from "@/styles/utils"
import { device_px, secondary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_1279, MAX_767 } = device_px

export const HeroWrapper = styled.div`
  position: relative;
  margin-top: ${rem(72)};
  padding-top: ${rem(146)};

  @media screen and (max-width: ${MAX_1279}) {
    margin-top: ${rem(67)};
    padding-top: ${rem(85)};
  }

  @media screen and (max-width: ${MAX_767}) {
    margin-top: ${rem(56)};
    padding-top: ${rem(77)};
  }
`

export const BgImg = styled.img`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const BgImgPc = styled(BgImg)`
  top: ${rem(56)};
  width: ${rem(1600)};

  @media screen and (max-width: ${MAX_1279}) {
    display: none;
  }
`
export const BgImgTab = styled(BgImg)`
  display: none;
  top: ${rem(34)};
  width: ${rem(768)};

  @media screen and (max-width: ${MAX_1279}) {
    display: block;
  }

  @media screen and (max-width: ${MAX_767}) {
    display: none;
  }
`

export const BgImgMo = styled(BgImg)`
  display: none;
  top: ${rem(36)};
  width: ${rem(360)};

  @media screen and (max-width: ${MAX_767}) {
    display: block;
  }
`

export const TitleWrapper = styled.div`
  position: relative;
  z-index: 1;
`

export const Title = styled.h3`
  font-size: ${rem(50)};
  font-weight: 700;
  line-height: 120%;
  letter-spacing: ${rem(-1.5)};
  color: ${secondary.text};
  text-align: center;

  @media screen and (max-width: ${MAX_1279}) {
    font-size: ${rem(28)};
    line-height: 140%;
    letter-spacing: ${rem(-0.84)};
  }
`

export const SubTitleWrapper = styled.div`
  position: relative;
  margin-top: ${rem(122)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${rem(14)};
  text-align: center;

  @media screen and (max-width: ${MAX_1279}) {
    margin-top: ${rem(50)};
  }
`

export const SubTitleLine = styled.span`
  font-size: ${rem(28)};
  font-weight: 700;
  line-height: 140%;
  letter-spacing: ${rem(-0.84)};

  @media screen and (max-width: ${MAX_1279}) {
    font-size: ${rem(18)};
    line-height: 141%;
    letter-spacing: ${rem(-0.54)};
  }

  @media screen and (max-width: ${MAX_767}) {
    white-space: pre-wrap;
  }
`

export const SubTitle = styled.span`
  height: 100%;
`

export const HighLight = styled.span`
  color: ${secondary.text};
`
